var exports = {
  "qr": "footer__vcTRm6",
  "Ic": "footerSpacer__mUrFDW",
  "ft": "regionHeading__6m4jbf",
  "nr": "hiddenRegion__698v7S",
  "p_": "list__lxKf7O",
  "nM": "row__V48i9e",
  "qg": "rowText__QdKBrw",
  "xZ": "rowLabel__Rh9nXN",
  "Z$": "rowDescription__P4ii5O",
  "Sq": "hiddenIcon__Sg_uO1",
};

module.exports = exports;
